/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var $canvas = document.getElementById('progress'),
    context = $canvas.getContext('2d'),
    positionX = $canvas.width / 2,
    positionY = $canvas.height / 2,
    onePercent = 360 / 100,
    colorPickerBlock = document.getElementById('hiddenBlock'),
    valueColor = '#291d41',
    detectedColor;


context.lineCap = 'round';
detectedColor = window.getComputedStyle(colorPickerBlock).backgroundColor;

if ( detectedColor ) {
    valueColor = detectedColor;
}


/**
 * Draw circle progress bar
 *
 * @param {number} percent - percent to fill circle
 */
function draw ( percent ) {
    context.clearRect(0, 0, $canvas.width, $canvas.height);
    context.beginPath();
    context.arc(positionX, positionY, 70, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + 360));
    context.strokeStyle = '#b1b1b1';
    context.lineWidth = '10';
    context.stroke();
    context.beginPath();
    context.strokeStyle = valueColor;
    context.lineWidth = '10';
    context.arc(positionX, positionY, 70, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + (percent * onePercent)));
    context.stroke();
}

/**
 * Clear canvas
 */
draw.clear = function () {
    context.clearRect(0, 0, $canvas.width, $canvas.height);
};


module.exports = draw;
